import React from 'react'
import './Footer.css'

const Footer = () => {
  return (
    <div className='footer'>
      <p>©2026 Suruchi Aayurvedic. All right reserved.</p>
      <ul>
        <li>Terms of service</li>
        <li>Privacy Policy</li>
      </ul>
    </div>
  )
}

export default Footer
